export default "Lav fine små lys af indsamlede muslingeskaller – næsten som i jægerstenalderen!";